import { Component } from "@angular/core";
import { CommonModule, AsyncPipe } from "@angular/common";
import { AiProcessingService } from "src/app/services/ai-processing.service";
import { combineLatest, map } from "rxjs";

@Component({
  selector: "app-ai-processing-modal",
  templateUrl: "./ai-processing-modal.component.html",
  styleUrls: ["./ai-processing-modal.component.scss"],
  standalone: true,
  imports: [CommonModule, AsyncPipe],
})
export class AiProcessingModalComponent {
  readonly vm$ = combineLatest([
    this.ai.config$,
    this.ai.taskState$,
    this.ai.currentStep$,
    this.ai.progress$,
    this.ai.elapsed$,
    this.ai.credits$,
  ]).pipe(
    map(([config, taskState, currentStep, progress, elapsed, credits]) => ({
      config,
      taskState,
      currentStep,
      progress,
      elapsed,
      credits,
      isComplete: taskState === "complete",
    })),
  );

  constructor(public ai: AiProcessingService) {}

  formatElapsed(ms: number): string {
    const totalSecs = Math.floor(ms / 1000);
    const mins = Math.floor(totalSecs / 60);
    const secs = totalSecs % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  }

  stepStatus(
    stepIndex: number,
    currentStep: number,
    isComplete: boolean,
  ): "completed" | "active" | "pending" {
    if (isComplete || stepIndex < currentStep) return "completed";
    if (stepIndex === currentStep) return "active";
    return "pending";
  }
}
